<template>
  <div class="animated fadeIn" style="height: 100%; width: auto">
    <b-card>
      <div slot="header">
        {{this.$route.meta.title}}
        <div class="card-header-actions">
          <button class="btn btn-primary mr-1" v-b-tooltip.hover title="Simpan data pelunasan." @click="save()"
            :disabled="savedisabled">
            <i class="fa fa-floppy-o"></i> {{ $t("save") }}
          </button>
          <button class="btn btn-primary mr-1" v-b-tooltip.hover title @click="close()">
            <i class="fa fa-close"></i> {{ $t("close") }}
          </button>
        </div>
      </div>
      <div slot="footer">
        <div class="card-footer-actions text-center">
          <button class="btn btn-primary mr-1" v-b-tooltip.hover title="Simpan data pelunasan." @click="save()">
            <i class="fa fa-floppy-o"></i> {{ $t("save") }}
          </button>
          <button class="btn btn-primary mr-1" v-b-tooltip.hover title @click="close()">
            <i class="fa fa-close"></i> {{ $t("close") }}
          </button>
        </div>
      </div>
      <h5>Debitur</h5>
      <hr>
      <b-row>
        <b-col cols="6">
          <b-input-group>
            <b-input-group-prepend>
              <label>CIF</label>
            </b-input-group-prepend>
            <b-form-input readonly v-model="frmdt.CustCode" @keyup.13.native="lkuNasabahShow = true"
              :state="!$v.frmdt.pinjamankey.$error"></b-form-input>
            <b-input-group-append>
              <b-btn text="Button" @click="lkuNasabahShow = true">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-col>
        <b-col cols="6">
          <b-input-group>
            <b-input-group-prepend>
              <label>Nama</label>
            </b-input-group-prepend>
            <b-form-input readonly v-model="frmdt.CustName"></b-form-input>
          </b-input-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="7">
          <b-row>
            <b-col lg="7">
              <b-input-group>
                <b-input-group-prepend>
                  <label>No.Kontrak</label>
                </b-input-group-prepend>
                <b-form-input readonly v-model="model.no_kontrak" @keyup.13.native="lkuPinjamanShow = true"
                  :state="!$v.frmdt.pinjamankey.$error"></b-form-input>
                <b-input-group-append>
                  <b-btn text="Button" @click="lkuPinjamanShow = true">
                    <i class="fa fa-search"></i>
                  </b-btn>
                </b-input-group-append>
              </b-input-group>
            </b-col>
            <b-col lg="5">
              <b-input-group>
                <b-input-group-prepend>
                  <label style="width: 79px">Tgl.Kontrak</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.tgl_kontrak" disabled></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="7">
              <b-input-group>
                <b-input-group-prepend>
                  <label>No. Agreement</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.no_agreement" disabled></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="5" style="display: flex;justify-content: left;align-items: center;">
              <a :href="viewaggrementcard()" target="_blank"><i class="fa fa-eye"></i> View Aggrement Card</a>
            </b-col>
          </b-row>
          <b-input-group>
            <b-input-group-prepend>
              <label>Debitur</label>
            </b-input-group-prepend>
            <b-form-input v-model="model.CustName" disabled></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Penggunaan</label>
            </b-input-group-prepend>
            <b-form-input v-model="model.pinjaman_uraian" disabled></b-form-input>
          </b-input-group>
        </b-col>
        <b-col lg="5">
          <b-col lg="10">
            <b-input-group>
              <b-input-group-prepend v-if="model.model_pinjaman == 'PAB'">
                <label style="width: 140px">Pokok Pinjaman</label>
              </b-input-group-prepend>
              <b-input-group-prepend v-else>
                <label style="width: 140px">Plafond Pinjaman</label>
              </b-input-group-prepend>
              <my-number v-if="model.model_pinjaman == 'PAB'" class="form-control text-right" v-model="model.principal"
                :precision="2" disabled></my-number>
              <my-number v-else class="form-control text-right" v-model="model.principal" :precision="2"
                disabled></my-number>
              <b-input-group-prepend>
                <span class="input-group-text" style="width: 70px">{{
                  model.matauang
                  }}</span>
              </b-input-group-prepend>
            </b-input-group>
            <b-input-group>
              <b-input-group-prepend>
                <label style="width: 140px">Jangka Waktu</label>
              </b-input-group-prepend>
              <my-number class="form-control text-right" v-model="model.tenor" :precision="0" disabled></my-number>
              <b-input-group-prepend>
                <span class="input-group-text" style="width: 70px">bulan</span>
              </b-input-group-prepend>
            </b-input-group>
            <b-input-group>
              <b-input-group-prepend>
                <label style="width: 140px">Bunga per tahun</label>
              </b-input-group-prepend>
              <my-number class="form-control text-right" v-model="model.bungaod_tarifthn" :precision="2"
                disabled></my-number>
              <b-input-group-prepend>
                <span class="input-group-text" style="width: 70px">%</span>
              </b-input-group-prepend>
            </b-input-group>
            <b-input-group v-if="model.model_pinjaman == 'PAB'">
              <b-input-group-prepend>
                <label style="width: 140px">Angsuran per bulan</label>
              </b-input-group-prepend>
              <my-number class="form-control text-right" v-model="model.installment_amount" :precision="2"
                disabled></my-number>
              <b-input-group-prepend>
                <span class="input-group-text" style="width: 70px">{{
                  model.matauang
                  }}</span>
              </b-input-group-prepend>
            </b-input-group>
            <b-input-group v-else>
              <b-input-group-prepend>
                <label>Bunga Over Draft</label>
              </b-input-group-prepend>
              <my-number class="form-control text-right" v-model="model.bungaod_tarifthn" :precision="2"
                disabled></my-number>
              <b-input-group-prepend>
                <span class="input-group-text" style="width: 70px">%</span>
              </b-input-group-prepend>
            </b-input-group>
          </b-col>
        </b-col>
      </b-row>
      <hr />
      <b-row class="mt-3">
        <b-col lg="8">
          <h5>Alokasi Pembayaran</h5>
          <b-table-simple responsive bordered>
            <b-thead class="text-center">
              <b-tr>
                <b-th>Fasilitas</b-th>
                <b-th style="width:250px;">Tercatat</b-th>
                <b-th style="width:250px;">Pembayaran</b-th>
                <b-th style="width:250px;">Sisa Kewajiban</b-th>
              </b-tr>
            </b-thead>
            <b-tbody>

              <b-tr>
                <b-td>Pokok</b-td>
                <b-td class="text-right pt-3">{{this.frmdt.principal_outstand |numFormat('0,0.00') }}</b-td>
                <b-td><my-number v-model="frmdt.principal_allocation" :precision="2"
                    class="text-right"></my-number></b-td>
                <b-td class="text-right pt-3">{{this.frmdt.principal_OSafteralloc |numFormat('0,0.00') }}</b-td>
              </b-tr>
              <b-tr>
                <b-td>Bunga</b-td>
                <b-td class="text-right pt-3">{{this.frmdt.interest_outstand |numFormat('0,0.00') }}</b-td>
                <b-td><my-number v-model="frmdt.interest_allocation" :precision="2"
                    class="text-right"></my-number></b-td>
                <b-td class="text-right pt-3">{{this.frmdt.interest_OSafteralloc |numFormat('0,0.00') }}</b-td>
              </b-tr>
              <b-tr>
                <b-td>Denda</b-td>
                <b-td class="text-right pt-3">{{this.frmdt.latecharge_outstand |numFormat('0,0.00') }}</b-td>
                <b-td><my-number v-model="frmdt.latecharge_allocation" :precision="2"
                    class="text-right"></my-number></b-td>
                <b-td class="text-right pt-3">{{this.frmdt.latecharge_OSafteralloc |numFormat('0,0.00') }}</b-td>
              </b-tr>
            </b-tbody>
            <b-tfoot>
              <b-tr>
                <b-td><b>Total</b></b-td>
                <b-td class="text-right pt-3"><b>{{this.frmdt.ttlOS |numFormat('0,0.00') }}</b></b-td>
                <b-td class="text-right pt-3 pr-4"><b>{{this.frmdt.ttlAllocation |numFormat('0,0.00') }}</b></b-td>
                <b-td class="text-right pt-3"><b>{{this.frmdt.ttlOSafteralloc |numFormat('0,0.00') }}</b></b-td>
              </b-tr>
            </b-tfoot>
          </b-table-simple>
        </b-col>
      </b-row>
      <hr />
      <b-row>
        <b-col lg="8">
          <b-row>
            <b-col lg="5">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Tgl Pengajuan</label>
                </b-input-group-prepend>
                <b-form-input type="date" v-model="frmdt.submitdate"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="5">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Tgl Jth. Tempo</label>
                </b-input-group-prepend>
                <b-form-input type="date" v-model="frmdt.duedate"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="5">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Nomor Surat</label>
                </b-input-group-prepend>
                <b-form-input v-model="frmdt.releaseno" :state="!$v.frmdt.releaseno.$error"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-input-group>
            <b-input-group-prepend>
              <label>Kronologis</label>
            </b-input-group-prepend>
            <b-form-textarea v-model="frmdt.kronologis" :state="!$v.frmdt.kronologis.$error" placeholder="" rows="5"
              max-rows="10"></b-form-textarea>
          </b-input-group>

          <b-row>
            <b-col lg="10">
              <b-input-group>
                <b-input-group-prepend>
                  <label style="">Pembayaran</label>
                </b-input-group-prepend>
                <b-input-group-prepend style="height: 35px">
                  <span class="input-group-text">IDR</span>
                </b-input-group-prepend>
                <div style="width:250px">
                  <my-number v-model="frmdt.paymentamt"
                    :state="!$v.frmdt.paymentamt.$error || (frmdt.paymentamt==frmdt.ttlAllocation)" :precision="2"
                    class="text-right"></my-number>
                  <label style="background-color: #dc3545;" v-if="$v.frmdt.paymentamt.$error">PERIKSA KEMBALI NILAI
                    PEMBAYARAN</label>
                  <label style="background-color: #dc3545;" v-if="frmdt.paymentamt!=frmdt.ttlAllocation">PEMBAYARAN
                    TIDAK SAMA DENGAN ALOKASI</label>
                </div>
              </b-input-group>
              <b-input-group>
                <b-input-group-prepend>
                  <label>Rencana Penarikan <br> Jaminan</label>
                </b-input-group-prepend>
                <b-form-input type="date" class="mt-2" v-model="frmdt.estimatereleasedt"
                  :state="!$v.frmdt.estimatereleasedt.$error"></b-form-input>
              </b-input-group>
              <b-input-group>
                <b-input-group-prepend>
                  <label>CC</label>
                </b-input-group-prepend>
                <b-form-textarea v-model="frmdt.cc" placeholder="" rows="4" max-rows="6"></b-form-textarea>
              </b-input-group>
            </b-col>
          </b-row>

        </b-col>
      </b-row>

      <hr>
      <b-row>
        <b-col lg="12">
          <h5>Daftar Jaminan</h5>
        </b-col>
      </b-row>

      <b-card align="center" no-body>
        <b-input-group class="m-1">
          <button class="btn btn-primary mr-1" v-b-tooltip.hover title="Simpan data pelunasan."
            @click="clearSelected()">
            <i class="fa fa-trash-o"></i> Clear selected
          </button>
        </b-input-group>
        <!-- <b-button size="sm" @click="selectAllRows">Select all</b-button> -->
        <!-- <b-button@click="clearSelected">Clear selected</b-button> -->
        <b-table sticky-header class="mb-0" ref="table" outlined responsive striped hover small
          style="font-size:smaller;max-height:500px !important;" :items="tblDataAsset.items" :fields="tblFieldsAsset"
          :current-page="tblDataAsset.page" :per-page="tblDataAsset.limit" :sort-by.sync="tblDataAsset.sortBy"
          :sort-desc.sync="tblDataAsset.sortDesc" :key="tblDataAsset.limit" :busy="isBusytblDataAsset" show-empty
          selectable @row-selected="onRowSelected" select-mode="multi">
          <template #cell(selected)="data">
            <!-- <template v-if="rowSelected">
                  <span aria-hidden="true">&check;</span>
                  <span class="sr-only">Selected</span>
                </template>
                <template v-else>
                  <span aria-hidden="true">&nbsp;</span>
                  <span class="sr-only">Not selected</span>
                </template> -->
            <input name="selectjaminan" type="checkbox" class="mt-0" style="transform: scale(1.5);"
              @change="checkedjaminan(data.item)" :checked="ischeckedjaminan(data.item.jaminankey)" />
          </template>

          <template v-slot:cell(index)="data">{{ data.index + 1 }}</template>
          <template v-slot:cell(nilaijaminan)="data">{{
            data.item.nilaijaminan | numFormat('0,0.00')
            }}</template>
          <template v-slot:cell(nilaimargin)="data">
            <b-input-group>
              <b-input-group-prepend style="height: 35px">
                <span class="input-group-text">IDR</span>
              </b-input-group-prepend>
              <my-number v-model="data.item.nilaimargin" :precision="2" class="text-right"></my-number>
            </b-input-group>
          </template>
          <template v-slot:cell(nilailikuidasi)="data">
            <b-input-group>
              <b-input-group-prepend style="height: 35px">
                <span class="input-group-text">IDR</span>
              </b-input-group-prepend>
              <my-number v-model="data.item.nilailikuidasi" :precision="2" class="text-right"></my-number>
            </b-input-group>
          </template>
          <template v-slot:cell(alamat)="data">
            {{ data.item.alamat || "-" }}

            <span v-if="(data.item.kelurahan ||'')!=''">
              <br />
              Kelurahan : {{ data.item.kelurahan }} - Kecamatan :{{
              data.item.kecamatan
              }}</span>
            <span v-if="(data.item.kota||'')!=''">
              <br />
              Kota : {{ data.item.kota }} - Provinsi :{{ data.item.provinsi }}
            </span>
            <span v-if="(data.item.kodepos||'')!=''">
              <br />
              Kode Pos : {{ data.item.kodepos }}
            </span>

          </template>
          <template v-slot:cell(detail)="data">
            <span v-if="data.item.tipejaminan == 'Kendaraan'">
              <b-row>
                <b-col md="6">- No. BPKB : {{ data.item.bpkb }}</b-col>
                <b-col md="6">- No. STNK : {{ data.item.stnk }}</b-col>
              </b-row>
              <b-row>
                <b-col md="6">- Status STNK : {{ data.item.statusstnk }}</b-col>
                <b-col md="6">- Tanggal STNK :
                  {{ data.item.tanggalstnk | moment("DD/MM/YY") }}</b-col>
              </b-row>
            </span>
            <span v-else>
              <b-row>
                <b-col md="6">- No Sertifikat : {{ data.item.sertifikatno }}</b-col>
                <b-col md="6">- Sertifikat Atas Nama : {{ data.item.pemilikjaminan }}</b-col>
              </b-row>
              <b-row>
                <b-col md="6">
                  - Luas Tanah : {{ data.item.luastanah }} m
                  <sup>2</sup>
                </b-col>
                <b-col md="6">
                  - Luas Bangunan : {{ data.item.luasbangunan }} m
                  <sup>2</sup>
                </b-col>
              </b-row>
              - Status Sertifikat : {{ data.item.sertifikatstatus }}
              <span v-if="data.item.sertifikatstatus === 'lainnya'">- {{ data.item.otherstatussertifikat }}</span>
              <b-row>
                <b-col md="6">- Status PBB : {{ data.item.statuspbb }}</b-col>
                <b-col md="6">- Tanggal PBB: {{ data.item.tanggalpbb }}</b-col>
              </b-row>
              <b-row>
                <b-col md="6">- Status Asuransi : {{ data.item.statusasuransi }}</b-col>
                <b-col md="6">- No. IMB : {{ data.item.noimb }}</b-col>
              </b-row>
            </span>
          </template>
          <template v-slot:cell(tgl_kontrak)="data">{{
            data.item.tgl_kontrak | moment("DD/MM/YY")
            }}</template>

          <template v-slot:table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
          <template v-slot:cell(empty)="data">
            <h4>{{ data.emptyText }}</h4>
          </template>
          <template v-slot:cell(emptyfiltered)="data">
            <h4>{{ data.emptyFilteredText }}</h4>
          </template>
        </b-table>
        <b-row class="mt-2">
          <b-col cols="4">
            <div align="left">
              Showing {{(tblDataAsset.page - 1) * tblDataAsset.limit + 1}}
              to
              <span v-if="((tblDataAsset.page * tblDataAsset.limit)>tblDataAsset.total)">{{tblDataAsset.total}}</span>
              <span v-else>{{tblDataAsset.page * tblDataAsset.limit}}</span>
              of {{tblDataAsset.total}} entries
            </div>
          </b-col>
          <b-col cols="4">
            <b-form-group label style="margin-top:0 !important;">
              <b-input-group>
                <b-input-group-prepend class="mr-2">
                  <label>Limit per page</label>
                </b-input-group-prepend>
                <div class="d-flex">
                  <b-form-select :options="[10, 15, 20, 25,50,75,100]" :plain="true" v-model="tblDataAsset.limit"
                    size="sm" style="width:80px" />
                </div>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col cols="4">
            <b-pagination align="right" :total-rows="tblDataAsset.total" :per-page="tblDataAsset.limit"
              v-model="tblDataAsset.page" @click="getAssetData()"></b-pagination>
          </b-col>
        </b-row>
      </b-card>

    </b-card>
    <b-modal v-model="lkuNasabahShow" size="lg" :hide-footer="true" title="Daftar Nasabah" :centered="true">
      <lku-customer @click="onSelectLkuNasabah"></lku-customer>
    </b-modal>
    <b-modal v-model="lkuPinjamanShow" size="lg" :hide-footer="true" title="Daftar Pinjaman" :centered="true">
      <lku-pinjaman @click="onSelectLkuPinjaman"></lku-pinjaman>
    </b-modal>
    <b-modal v-model="showReport" size="lg" title="Preview as PDF" ok-only>
      <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4"></loading>
  </div>
</template>

<script>
import toastr from "mini-toastr";
import moment from "moment";
import myNumber from "../../components/my-number";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import lkuPinjaman from "./lkuPinjamanSimple";
import lkuCustomer from "../lookup/lkuCustomer.vue";
import pinjaman from "../../apis/pinjamankredit";
import pelunasan from "../../apis/pelunasanpinjaman";
import asset from "../../apis/agunankredit";
import releasedoc from "../../apis/releasedoc";

// import crud from "../../apis/crud";
import { validationMixin } from "vuelidate";
import { required,minValue } from "vuelidate/lib/validators";
toastr.init();

export default {
  components: { myNumber, lkuPinjaman, Loading,lkuCustomer },
  mixins: [validationMixin],
  validations: {
    frmdt: {
      pinjamankey: { required },
      releaseno: { required },
      kronologis:{ required },
      paymentamt:{ required ,minValue:minValue(1)},
      estimatereleasedt:{ required }
    },
  },
  data() {
    return {
      savedisabled:false,
      lkuNasabahShow:false,
      showReport: false,
      reportUrl: null,
      isLoading: false,
      text: "",
      isBusy: false,
      isBusytblDataAsset:false,
      isPelunasankey: false,
      model: {},
      frmdt: {
        releaseKey:'',
        nasabahkey:'',
        CustCode:'',
        CustName:'',
        pinjamankey: "",
        submitdate: moment().format("YYYY-MM-DD"),
        duedate: moment().add(1,'month').format("YYYY-MM-DD"),
        tglpelunasan: moment().format("YYYY-MM-DD"),
        hariini: moment().format("YYYY-MM-DD"),
        releaseno: "",
        kronologis:'',
        paymentamt:0,
        jaminanamt:0,
        principal_outstand:0,
        interest_outstand:0,
        latecharge_outstand:0,
        principal_allocation:0,
        interest_allocation:0,
        latecharge_allocation:0,
        principal_OSafteralloc:0,
        interest_OSafteralloc:0,
        latecharge_OSafteralloc:0,
        ttlOS:0,
        ttlAllocation:0,
        ttlOSafteralloc:0,
        kepada: "Komite Kredit",
        perihal: "Credit Settlement Approval",
        lokasiLDSK1: "",
        lokasiLDSK2: "",
        ttd1_diajukan_nama: "",
        ttd1_diajukan_jabatan: "",
        ttd1_mengetahui_nama: "",
        ttd1_mengetahui_jabatan: "",
        ttd1_disetujui_nama: "",
        ttd1_disetujui_jabatan: "",
        cc: "- Loan Admin (untuk menyiapkan SKL & surat roya) \n- Audit",
        docReleaseArr:[]
     },
      tblDataAsset: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: "jaminankey",
        sortDesc: false,
        pemilikjaminan: null,
        lokasijaminan: null,
        nilai1: 0,
        nilai2: 0,
        no_kontrak: null,
        tipejaminan: "",
        statusasuransi: "",
        jaminankeys: [],
        sourceproject: this.$store.state.user.compcode||"",
      },
      ifCalculated: false,
      stateTtlPay: true,
      lkuPinjamanShow: false,
      optionsPelunasan: [
        { item: "Normal", name: "Normal" },
        { item: "Bertahap", name: "Bertahap" },
      ],
      documentSelected: []
    };
  },
  computed: {
    invalidFrmDt() {
      this.$v.frmdt.$touch();
      return this.$v.frmdt.$invalid;
    },
    canSave() {
      return this.ifCalculated;
    },
    ifBertahap() {
      return this.frmdt.tipepelunasan == "Bertahap" ? true : false;
    },
    tblFieldsAsset() {
      const fields = [
        'selected',
        { key: "index", label: "#" },
        {
          key: "detail",
          label: "Detail",
          thClass: "text-center",
          tdClass: "text-left",
          thStyle: "width:2000px",
          sortable: true,
        },
        {
          key: "pemilikjaminan",
          label: "Pemilik Jaminan",
          thClass: "text-center",
          tdClass: "text-left",
          thStyle: "width:500px",
          sortable: true,
        },
        {
          key: "alamat",
          label: "Alamat",
          thClass: "text-center",
          tdClass: "text-left",
          thStyle: "width:1500px",
          sortable: true,
        },
        
        {
          key: "nilaijaminan",
          label: "Nilai Jaminan",
          thClass: "text-center",
          tdClass: "text-right",
          thStyle: "width:700px",
          sortable: true,
        },
         {
          key: "nilaimargin",
          label: "Nilai Margin",
          thClass: "text-center",
          tdClass: "text-right",
          thStyle: "width:700px",
          sortable: true,
        },
         {
          key: "nilailikuidasi",
          label: "Nilai Likuidasi",
          thClass: "text-center",
          tdClass: "text-right",
          thStyle: "width:700px",
          sortable: true,
        }
      ];
      return fields;
    },
  },
  watch: {
    "frmdt.principal_allocation"(val) {
      this.frmdt.principal_OSafteralloc = this.frmdt.principal_outstand - val;
      this.calcpaymn();
    },
    "frmdt.interest_allocation"(val) {
      this.frmdt.interest_OSafteralloc = this.frmdt.interest_outstand - val;
      this.calcpaymn();
    },
    "frmdt.latecharge_allocation"(val) {
      this.frmdt.latecharge_OSafteralloc = this.frmdt.latecharge_outstand - val;
      this.calcpaymn();
    }
  },
  created: async function () {
    this.model.model_pinjaman = "PAB";
    if (this.$route.params.releaseKey) {
      toastr.info("Loading Payment Detail, please wait");
      this.isPelunasankey = true;
      try {
        const res = await releasedoc.detail(this.$route.params.releaseKey);
        const header = res[0][0];
        const assetRelease = res[1];
        let assets = res[2];
        let documentSelected=[];
        console.log('assetRelease',assetRelease);
        assetRelease.map((asset)=>{
            let index = assets.findIndex(x=>x.jaminankey == asset.jaminankey);
            documentSelected.push(assets[index]);
            assets[index].rowSelected=true;
        });
        console.log('documentSelected',documentSelected);
        this.documentSelected = documentSelected;

        this.tblDataAsset.items=assets;
        this.tblDataAsset.total = assets.length;

        for (const key in header) {
          this.model[key] = header[key];
          this.frmdt[key] = header[key];
        }
        
        this.frmdt.submitdate = this.frmdt.submitdate
          ? moment(this.frmdt.submitdate).format("YYYY-MM-DD")
          : "";
        this.frmdt.duedate = this.frmdt.duedate
          ? moment(this.frmdt.duedate).format("YYYY-MM-DD")
          : "";
        this.model.tgl_kontrak = this.model.tgl_kontrak
          ? moment(this.model.tgl_kontrak).format("DD-MMM-YYYY")
          : "";
        this.frmdt.estimatereleasedt = this.frmdt.estimatereleasedt
          ? moment(this.frmdt.estimatereleasedt).format("YYYY-MM-DD")
          : "";

        this.frmdt.tipepelunasan = header.tipepelunasan;
        this.frmdt.nilaijaminan = header.nilaijaminan;

        toastr.clear;
      } catch (error) {
        console.log("error : ", error);
        toastr.error(JSON.stringify(error), "ERROR MESSAGE");
      }
      this.frmdt.ttd1_diajukan_nama = this.model.ttd1_diajukan_nama ? this.model.ttd1_diajukan_nama : "-"; //Diajukan Oleh
      this.frmdt.ttd1_diajukan_jabatan = this.model.ttd1_diajukan_jabatan ? this.model.ttd1_diajukan_jabatan : "-"; //Diajukan Oleh
    }else{
      this.frmdt.ttd1_diajukan_nama = this.model.ttd1_diajukan_nama ? this.model.ttd1_diajukan_nama : this.$store.state.user.full_name; //Diajukan Oleh
      this.frmdt.ttd1_diajukan_jabatan = this.model.ttd1_diajukan_jabatan ? this.model.ttd1_diajukan_jabatan : this.$store.state.user.jabatan; //Diajukan Oleh
   
       
    }

      const dataWF = await releasedoc.getworkflow();
      this.frmdt.ttd1_mengetahui_nama = this.model.ttd1_mengetahui_nama ? this.model.ttd1_mengetahui_nama : dataWF[0].full_name; //Mengetahui
      this.frmdt.ttd1_mengetahui_jabatan = this.model.ttd1_mengetahui_jabatan ? this.model.ttd1_mengetahui_jabatan : dataWF[0].jabatan; //Mengetahui
      this.frmdt.ttd1_disetujui_nama = this.model.ttd1_disetujui_nama ? this.model.ttd1_disetujui_nama : dataWF[1].full_name; //Disetujui Oleh
      this.frmdt.ttd1_disetujui_jabatan = this.model.ttd1_disetujui_jabatan ? this.model.ttd1_disetujui_jabatan : dataWF[1].jabatan; //Disetujui Oleh
  
    
  },
  methods: {
      onRowSelected(items) {
        this.documentSelected = items
      },
      selectAllRows() {
        this.$refs.table.selectAllRows()
      },
      clearSelected() {
        this.$refs.table.clearSelected()
      },
    ischeckedjaminan(val){
      console.log('this.documentSelected',this.documentSelected);
      const findjaminan = this.documentSelected.find(x => (x.jaminankey === val));
      if(findjaminan){
        return 'checked'
      }else{
        return '';
      }
    },
    checkedjaminan(item) {
      const {jaminankey} = item;
      const findCheck = this.documentSelected.find(x => ((x.jaminankey === jaminankey)));
      if (!(findCheck)){
        this.documentSelected.push(item);
      }else{
        this.documentSelected.splice(findCheck, 1);
        this.documentSelected.push(item);
      }
      // if (item.target.checked === true) {
      //   const findCheck = this.documentSelected.find(x => ((x.jaminankey === jaminankey)));
      //   if (!(findCheck)){
      //     this.documentSelected.push(item);
      //   }else{
      //     this.documentSelected.splice(findCheck, 1);
      //     this.documentSelected.push(item);
      //   }
      // } else {
      //   const findIdx = this.documentSelected.findIndex(x => ((x.jaminankey === jaminankey)));
      //   this.documentSelected.splice(findIdx, 1);
      // }
    },
    async onSelectLkuNasabah(_selected){
      try {
          console.log('_selected',_selected)
          this.frmdt.nasabahkey = _selected.nasabahkey;
          this.frmdt.CustCode = _selected.CustCode;
          this.frmdt.CustName = _selected.CustName;
          this.lkuNasabahShow = false;
      } catch (error) {
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    async onSelectLkuPinjaman(_selected) {
      if((_selected.pelunasankey || '')!=''){
        toastr.warn(`Pinjaman sudah memiliki memo pelunasan. No memo : ${_selected.nosurat}`, "INFO","5000");
      }else{
        this.frmdt.pinjamankey = _selected.pinjamankey;
        this.frmdt.nasabahkey = _selected.nasabahkey;
        this.frmdt.pinalty_rate = _selected.pinalty_rate ? _selected.pinalty_rate : "8"; //default 8% pinalty
        for (const key in _selected) {
          this.model[key] = _selected[key];
        }
        this.model.tgl_kontrak = _selected.tgl_kontrak
          ? moment(_selected.tgl_kontrak).format("DD-MM-YYYY")
          : "";
        this.model.pinjaman_uraian = _selected.uraian;
        this.model.ttllatecharge = 0;
        this.frmdt.lokasiLDSK1=_selected.branch;
        this.frmdt.lokasiLDSK2=_selected.LDSK;
        this.frmdt.principal_outstand=_selected.principal_outstand;
        this.frmdt.interest_outstand=_selected.interest_outstand;
        this.frmdt.latecharge_outstand=_selected.latecharge_outstand;
        const getJaminan = await asset.getjaminan(_selected.pinjamankey);
        this.frmdt.nilaijaminan=getJaminan[0].nilaijaminan;
        console.log('this.frmdt',this.frmdt);
        console.log('_selected',_selected);
      }
      
      this.lkuPinjamanShow = false;
      this.getAssetData();
    },
    async calculate() {
      try {
        if (this.invalidFrmDt) {
          // console.log("validation : ", this.$v.issuedLinesObj);
          // console.log("model obj : ", this.issuedLinesObj);
          toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
        } else {
          this.isLoading = true;
          const data = await pinjaman.calcpelunasan(this.frmdt);
          const today = moment();
          const tglpelunasan = moment(this.frmdt.tglpelunasan);
          let diffDays = tglpelunasan.diff(today, "days");

          const {
            model_pinjaman,
            principal: pjmPrincipal,
            duedate: ODdate,
            bungaod_tarifthn,
            bunga_tarifthn,
          } = this.model;
          const { bbnPinjamanCurr, bbnPinjamanPelunasan } = data;
          // START total beban sampai hari ini
          this.frmdt.ttlinstalmentcurrent = bbnPinjamanCurr.ttlangsuran;
          this.frmdt.ttlprincipalcurrent = bbnPinjamanCurr.OS_Principal_Amount;
          this.frmdt.ttlinterestcurrent = bbnPinjamanCurr.OS_Interest_Amount;
          this.frmdt.ttllatechargecurrent = bbnPinjamanCurr.ttllatecharge;
          this.frmdt.cessie_etm = bbnPinjamanCurr.cessie_etm;

          this.frmdt.ttlosprincipal_untilmaturity = bbnPinjamanPelunasan.OS_Principal_Amount;
          // END

          if (model_pinjaman == "PRK") {
            // current
            this.frmdt.ttlprincipalcurrent = pjmPrincipal;
            this.frmdt.ttlinterestcurrent =
              bbnPinjamanCurr.sum_bungahrian_interest;
            // sampai pelunasan
            this.frmdt.ttlprincipal = pjmPrincipal;
            this.frmdt.ttlinterest =
              bbnPinjamanPelunasan.sum_bungahrian_interest;

            this.frmdt.ttlangsuran =
              this.frmdt.ttlprincipal + this.frmdt.ttlinterest;
            this.frmdt.ospokokbelumjt = bbnPinjamanPelunasan.os_pokok_blm_jt;
            this.frmdt.dendalain = 0; //tanyakan kembali dendalain
            this.frmdt.pinalty = 0; //tanyakan kembali pinalty

            if (diffDays > 0) {
              diffDays += 1;
              let diffODDays = today.diff(moment(ODdate), "days");
              let ifOverDue = diffODDays > 0 ? true : false;
              const interestPrcnt = ifOverDue
                ? bungaod_tarifthn
                : bunga_tarifthn;
              const interest =
                pjmPrincipal * (interestPrcnt / 100 / 360) * diffDays;
              this.frmdt.ttlinterest += interest;
            }
          }

          if (model_pinjaman == "PAB") {
            // START total beban sampai tanggal pelunasan
            this.frmdt.ttlinstalment =
              bbnPinjamanPelunasan.sum_angsrn_installment;
            this.frmdt.ttlprincipal = bbnPinjamanPelunasan.sum_angsrn_principal;

            this.frmdt.ttllatecharge =
              bbnPinjamanPelunasan.sum_nilai_dendahrian;
            this.frmdt.ttlinterest = bbnPinjamanPelunasan.sum_angsrn_interest;

            this.frmdt.ttlangsuran =
              this.frmdt.ttlprincipal + this.frmdt.ttlinterest;
            this.frmdt.ospokokbelumjt = bbnPinjamanPelunasan.os_pokok_blm_jt;
            this.frmdt.dendalain = bbnPinjamanPelunasan.dendalain;
            this.frmdt.pinalty = 0;

            // END

            // START HITUNG ULANG DENDA SAMPAI TANGGAL PELUNASAN
            // if (diffDays > 0) {
            //   diffDays += 1;
            //   const ttlDendaSmpaiLns =
            //     diffDays *
            //     (bbnPinjamanCurr.sum_angsrn_principal *
            //       (this.model.denda_tarifhri / 100));
            //   this.frmdt.ttllatecharge += ttlDendaSmpaiLns;
            // }
            // END
          }

          for (const key in bbnPinjamanPelunasan) {
            this.frmdt[key] = bbnPinjamanPelunasan[key];
          }

          this.calcpaymn();
          this.ifCalculated = true;
          this.isLoading = false;
        }
      } catch (error) {
        this.isLoading = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    calcpaymn() {
      this.frmdt.ttlOS= this.frmdt.principal_outstand+this.frmdt.interest_outstand+this.frmdt.latecharge_outstand;
      this.frmdt.ttlAllocation= this.frmdt.principal_allocation+this.frmdt.interest_allocation+this.frmdt.latecharge_allocation;
      this.frmdt.ttlOSafteralloc= this.frmdt.principal_OSafteralloc+this.frmdt.interest_OSafteralloc+this.frmdt.latecharge_OSafteralloc;

    },
    tooglePrintSave(param) {
      //console.log("$param: ", param);
      if (!param) {
        this.printPelunasanpdf();
      } else {
        this.simpanCetak();
      }
    },
    async simpanCetak() {
      if (this.invalidFrmDt) {
        // console.log("validation : ", this.$v.model);
        // console.log("model obj : ", this.model);
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
      } else {
        if (this.frmdt.ttlpayment == 0) {
          this.stateTtlPay = false;
          toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
        } else {
          //disini cek api dulu, apakah nomor surat memo pelunasan sudah pernah ada sebelumnya!
          const dataNomorMemo = await pelunasan.ceknomorMemo(this.frmdt);
          if(!this.$route.params.pelunasankey && dataNomorMemo){
            toastr.warn(`Memo pelunasan dengan nomor surat: ${dataNomorMemo.nosurat} sudah pernah dibuat sebelumnya. Silahkan cek kembali nomor surat!`, "INFO","8000");
          }else{
            const pelunasankey = await pelunasan.save(this.frmdt);
            this.frmdt.pelunasankey = pelunasankey;
            toastr.success("Data berhasil disimpan");
            this.printPelunasanpdf();
            router.push({ name: "loan.pelunasan" });
          }
        }
      }
    },
    async printPelunasanpdf() {
      try {
        this.isLoading = true;
        this.reportUrl = await pelunasan.printPDFMemoPelunasan(
          this.frmdt.pelunasankey
        );
        this.isLoading = false;
        this.showReport = true;
      } catch (error) {
        this.showReport = false;
        this.isLoading = false;
        console.log("error : ", error);
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    close() {
      router.push({ name: "loan.memopelepasanjaminansebagian" });
    },
    async save() {
      if (this.invalidFrmDt) {
        console.log("validation : ", this.$v.frmdt);
        // console.log("model obj : ", this.model);
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
      } else {
        if(this.documentSelected.length==0){
          toastr.error("Pilih setidaknya 1 jaminan.", "ERROR MESSAGE");
        }else if(this.documentSelected.length==this.tblDataAsset.total){
          toastr.error("Tidak dapat merelase seluruh jaminan", "ERROR MESSAGE");
        }
        else{
            let jaminanamt =0;
            let nilailikuidasi = 0;
            console.log('this.documentSelected',this.documentSelected)
            this.documentSelected.map((item)=>{
              jaminanamt += item.nilaijaminan;
              nilailikuidasi += item.nilailikuidasi;
            });

            this.frmdt.docReleaseArr=this.documentSelected;
            this.frmdt.jaminanamt = jaminanamt;
            this.frmdt.nilailikuidasi = nilailikuidasi;
            const data = await releasedoc.save(this.frmdt);
            this.frmdt.releaseKey = data.releaseKey;
            toastr.success("Data berhasil disimpan");
            router.push({ name: "loan.memopelepasanjaminansebagian" });
        }
      }
    },
    viewaggrementcard(){
      const url = router.resolve({name:'loan.agreementcardparams',params:{pinjamankey:this.model.pinjamankey}}).route.path;
      return `#`+url;
    },
    async getAssetData(){
      try {
        this.isLoading=true;
        const list = await asset.getAsset(this.model.pinjamankey);
        this.tblDataAsset.items=list;
        this.tblDataAsset.total = list.length;
        if(list.length<1){
          toastr.warn('Tidak dapat mengajukan pelepasan jaminan.Pinjaman ini hanya memiliki satu jaminan');
          this.savedisabled=true;
        }
        this.isLoading=false; 
      } catch (error) {
        this.isLoading = false;
        console.log("error : ", error);
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
  },
};
</script>
